export default "__VITE_ASSET__CRSmS0wb__"